import { useDispatch, useSelector } from "react-redux"
import { setOpenMainMenu, setOpenModalAddStaff, setOpenRevenue, setOpenStaffManagment } from "../../Reducer/ModalSlice"
import { ChangeValueAddStaff, CleanValueAddStaff } from "../../Reducer/AddStaffSlice"
import { useState } from "react"
import axios from "axios"
import { EditPost, StaffArrayAdd, StaffHours, StaffOneDaySumHours, StaffSelectedCityArrayAdd, setHoursStaff } from "../../Reducer/StaffSlice"
import { IoClose } from "react-icons/io5"
import { FaCheck } from "react-icons/fa6"


function AddStaffModalWindow() {
    const SelectedCity = useSelector(state => state.CitySlice.SelectedCity)
    const CityArray = useSelector(state => state.CitySlice.CityArray)   

    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const AddStaffSlice = useSelector(state => state.AddStaffSlice.AddedStaff)
    const EditStaff = useSelector(state => state.AddStaffSlice.EditStaff)

    const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)

    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
    
    const StaffAllMonth = useSelector(state => state.StaffSlice.StaffAllMonth) 

    const Period = useSelector(state => state.PeriodSlice.Period)

    const dispatch = useDispatch()
    const [OpenInputPost, setOpenInputPost] = useState(false)
    const [SelectedCityAddStaff, setSelectedCityAddStaff] = useState(SelectedCity)
    const [InputPostValue, setInputPostValue] = useState('')
    const [SearchingCity, setSearchingCity] = useState(CityArray)
    const [OpenSearchingCity, setOpenSearchingCity] = useState(false)
    const [CancelTouch, setCancelTouch] = useState(false)
    const [isLoading, setLoading] = useState(true)
    const [SuscessLoading, setSuscessLoading] = useState(false)
    
    const handleClickSaveButton = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        setLoading(false)
        var ErorrCheck = 0
        var PostCheck = ''
        var NewStaff = ''
        var ArrayStaff = ''
        if(SelectedCityAddStaff.id === 0 )
            {
                ErorrCheck = ErorrCheck + 1
                document.getElementById('SearchingInputAddStaff City').classList.add('Allert')
            }
        if(AddStaffSlice.FIO === '')
            {
                ErorrCheck = ErorrCheck + 1
                document.getElementById('InputModalFIO').classList.add('Allert')
            }
        
        if(AddStaffSlice.Shift === 0 && !EditStaff)
            {
                ErorrCheck = ErorrCheck + 1
                document.getElementById('InputModalShift').classList.add('Allert')
            }
        if(AddStaffSlice.Post === '' && InputPostValue === '')
            {
                ErorrCheck = ErorrCheck + 1
                document.getElementById('PostAddStaffDivText').classList.add('Allert')
            }
            else
            {
                if(AddStaffSlice.Post === '')
                    {
                        PostCheck = InputPostValue
                    }
                    else
                    {
                        PostCheck = AddStaffSlice.Post
                    }
            }
        if(ErorrCheck === 0)
        {
            if(!EditStaff)
            {
                await axios.post(Server + 'staff', {
                        FIO: AddStaffSlice.FIO,
                        Rate: parseFloat(AddStaffSlice.Rate).toFixed(2),
                        Shift: parseFloat(AddStaffSlice.Shift).toFixed(2),
                        Prize: parseFloat(AddStaffSlice.Prize).toFixed(2),
                        Post: String(PostCheck),
                        idCity: parseInt(SelectedCityAddStaff.id)
                }, {
                    headers: {
                    Authorization: 'Bearer ' + User.jwt,
                    },
                })
                .then(() => {
                    setSuscessLoading(true)
                })
                .catch(() => {
                    alert('Введенные данные не верны')
                })
            }
            else
            {
            await axios.put(Server + 'staff/' + AddStaffSlice.id, {
                    FIO: AddStaffSlice.FIO,
                    Post: String(PostCheck),
            }, {
                headers: {
                Authorization: 'Bearer ' + User.jwt,
                },
            })
            .then(() => {
                setSuscessLoading(true)
            })
            .catch(() => {
                alert('Введенные данные не верны')
            })

            await axios.get(Server + 'staff/' + AddStaffSlice.id , {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                },
            })
            .then((response) => {
                dispatch(EditPost(response.data))
            })
            }

                if(!EditStaff)
                {
                    await axios.get(Server + 'staff?_limit=-1', {
                        headers: {
                            Authorization: 'Bearer ' + User.jwt,
                        },
                    })
                    .then((response) => {
                        NewStaff = response.data
                    })
                    NewStaff = NewStaff[NewStaff.length - 1]
                    

                    await axios.get(Server + 'staffofthemonths?_limit=-1', {
                        headers: {
                            Authorization: 'Bearer ' + User.jwt,
                        },
                    })
                    .then((response) => {
                        ArrayStaff = response.data
                    })
                }

                if(!EditStaff)
                {
                ArrayStaff = ArrayStaff.filter((el) => el.idStaff === ArrayStaff[ArrayStaff.length - 1].idStaff)

                await ArrayStaff.map((el) => {
                    var Day = ''
                    if(el.MonthValue >= parseInt(new Date().getMonth() + 1))
                    {
                        if(el.MonthValue === 1 || el.MonthValue === 3 || el.MonthValue === 5 || el.MonthValue === 7 || el.MonthValue === 8 || el.MonthValue === 10 || el.MonthValue === 12) 
                        {
                            Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                        }
                        else
                        {
                            if(el.MonthValue === 2)
                            {
                                if(el.YearValue % 4 === 0 && (el.YearValue % 100 !== 0 || el.YearValue % 400 === 0)) 
                                {
                                    Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                                }
                                else
                                {
                                    Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                                }
                            }
                            else
                            {
                                Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                            }
                        }
                    
                        
                        axios.post(Server + 'staffofthemonths', {
                        idStaff: NewStaff.id,
                        Hours: Day,
                        Additional: '0_0_0_0',
                        Rate: parseFloat(AddStaffSlice.Rate).toFixed(2),
                        SecondRate: parseFloat(AddStaffSlice.Rate).toFixed(2),
                        Shift: parseFloat(AddStaffSlice.Shift).toFixed(2),
                        SecondShift: parseFloat(AddStaffSlice.Shift).toFixed(2),
                        Prize: parseFloat(AddStaffSlice.Prize).toFixed(2),
                        SecondPrize: parseFloat(AddStaffSlice.Prize).toFixed(2),
                        Hidden: false,
                        YearValue: el.YearValue,
                        MonthValue: el.MonthValue
                    }, {
                        headers: {
                        Authorization: 'Bearer ' + User.jwt,
                        },
                    })
                }
                    return(el)
                })
            }
            if(EditStaff)
            {
                axios.get(Server + "staff?_limit=-1", {
                    headers: {
                        Authorization: 'Bearer ' + User.jwt,
                    },
                })
                .then((responseStaff) => {
                    let DataStaff = responseStaff.data
                    axios.get(Server + 'staffofthemonths?_limit=-1', {
                        headers: {
                            Authorization: 'Bearer ' + User.jwt,
                        },
                    })
                    .then((responseStafffAllMonth) => {
                        let Chekeri = 6
                        if(DataStaff.length < 6)
                        {
                            Chekeri = DataStaff.length - 1
                        }
                        for (var i = 1; i < Chekeri; i++)
                            {
                                
                                let DataStaffId = DataStaff[DataStaff.length - i].id
                                let Cheker = responseStafffAllMonth.data.filter((a) => a.idStaff === DataStaffId)
                                if(Cheker.length === 0)
                                {
                                    axios.delete(Server + "staff/" + DataStaffId, {
                                        headers: {
                                            Authorization: 'Bearer ' + User.jwt,
                                        },
                                    })
                                }
                            }
                    })
                    
                    dispatch(StaffArrayAdd(DataStaff))                
                        dispatch(StaffSelectedCityArrayAdd(responseStaff.data.filter((a) => a.idCity === SelectedCity.id && (parseInt(new Date(a.created_at).getMonth() + 1) <= parseInt(SelectedMonth.MonthValue) || parseInt(new Date(a.created_at).getFullYear()) < parseInt(SelectedMonth.YearValue)))))
                        responseStaff.data.map((a) => {
                            StaffAllMonth.map((itemStaff) => {
                                if(itemStaff.YearValue === SelectedMonth.YearValue && itemStaff.MonthValue === SelectedMonth.MonthValue && a.id === itemStaff.idStaff)
                                dispatch(setHoursStaff({idHourses: itemStaff.id, idStaff: itemStaff.idStaff, Hours: itemStaff.Hours, Additional: itemStaff.Additional, Rate: itemStaff.Rate, Shift: itemStaff.Shift, Prize: itemStaff.Prize, SecondRate: itemStaff.SecondRate, SecondShift: itemStaff.SecondShift, SecondPrize: itemStaff.SecondPrize, Hidden: itemStaff.Hidden}))
                                return(itemStaff)
                                })
                                return(a)
                                })      
                            
                        dispatch(StaffHours({MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
                        RevenueArray.map((a) => {
                            if(a.id > -1 && a.id < (RevenueArray.length))
                            dispatch(StaffOneDaySumHours(a.id))
                            return(a)
                        })                
                })
            }

            setLoading(true)
            setTimeout(() => {
                dispatch(setOpenModalAddStaff(false))   
                if(!EditStaff) dispatch(setOpenMainMenu(true));
                if(EditStaff) {
                    dispatch(setOpenStaffManagment(true));
                    dispatch(setOpenRevenue(true));
                }
                dispatch(CleanValueAddStaff())
            }, 500)
        }
    }

    if(!isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigSpin"
                />
            </div>
        )

    if(SuscessLoading && isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigCheckDiv"
                >
                    <FaCheck className="BigCheckIcon"/>
                </div>
            </div>
        )

    return(
        <div
        className="ModalGlobalDiv"
        onClick={(() => {
            setOpenSearchingCity(false)
            document.getElementById('SearchingInputAddStaff City').value = document.getElementById('SearchingInputAddStaff City').defaultValue
            setSearchingCity(CityArray)
        })}
        onTouchStart={() => {
            setCancelTouch(false)
        }}
        onTouchMove={() => {
            setCancelTouch(true)
        }}
        onTouchCancel={() => {
            setCancelTouch(true)
        }}
        onTouchEnd={( async (event) => {
            event.preventDefault()
            if(!CancelTouch)
            {
                setOpenSearchingCity(false)
                document.getElementById('SearchingInputAddStaff City').value = document.getElementById('SearchingInputAddStaff City').defaultValue
                setSearchingCity(CityArray)
                document.getElementById('SearchingInputAddStaff City').blur()
            }
        })}
        >
            <div
            className="ModalMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div>

                    </div>
                    <div
                    className="ModalInformationTextDiv"
                    >
                        {!EditStaff ? 'Добавление нового сотрудника' : 'Изменение сотрудника'}
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() =>{
                        setSearchingCity(CityArray)
                        setOpenSearchingCity(false)
                        dispatch(setOpenModalAddStaff(false))
                        if(!EditStaff)
                        {
                            dispatch(setOpenMainMenu(true))
                        }
                        else
                        {
                            dispatch(setOpenStaffManagment(true))
                            dispatch(setOpenRevenue(true))
                        }
                        dispatch(CleanValueAddStaff())
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) =>{
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            setSearchingCity(CityArray)
                            setOpenSearchingCity(false)
                            dispatch(setOpenModalAddStaff(false))
                            if(!EditStaff)
                            {
                                dispatch(setOpenMainMenu(true))
                            }
                            else
                            {
                                dispatch(setOpenStaffManagment(true))
                                dispatch(setOpenRevenue(true))
                            }
                            dispatch(CleanValueAddStaff())
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>

                <div
                className="AddStaffGapDiv"
                >
                    <div
                    className="InputModalMainDiv AddStaff"
                    >
                        <div
                        className="InputModalMainDiv AddStaff"
                        >
                            <div
                            className="InputModalTextDiv"
                            id='CityAddStaffDivText'
                            >
                            {'Филиал: '} 
                            </div>
                            <div>
                                <input
                                className="SearchingInputAR"
                                placeholder="Выбор филиала"
                                id='SearchingInputAddStaff City'
                                defaultValue={SelectedCityAddStaff.id !== 0 ? SelectedCityAddStaff.City + ' ' + SelectedCityAddStaff.Adress : ''} 
                                onClick={((event) => {     
                                    event.stopPropagation()                          
                                    document.getElementById('SearchingInputAddStaff City').value = ''
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()  
                                    if(!CancelTouch)
                                    {
                                        event.stopPropagation()
                                        document.getElementById('SearchingInputAddStaff City').value = ''
                                        document.getElementById('SearchingInputAddStaff City').focus()
                                    }
                                })}
                                onFocus={(() => {
                                    setOpenSearchingCity(true)
                                })}
                                onChange={((e) => {
                                    var Val = e.target.value.toLowerCase()
                                    setSearchingCity(CityArray.filter((el) => 
                                        (el.City + ' ' + el.Adress).toLowerCase().includes(Val)
                                    ))
                                })}
                                />
                                {OpenSearchingCity && !EditStaff &&
                                <div
                                className="SelectorCitiesAddStaff"
                                >
                                    <div
                                    className="SelectorCitiesContainAddStaff"
                                    >
                                        {SearchingCity.map((el) => 
                                        <button
                                        key={el.id}
                                        className="SelectorOneCityButtonAddStaff"
                                        id={"SelectorOneCityButtonAddStaff" + el.id}
                                        onClick={(async (event) => {
                                            event.stopPropagation()
                                            await setSelectedCityAddStaff(el)
                                            document.getElementById('SearchingInputAddStaff City').value = document.getElementById('SearchingInputAddStaff City').defaultValue
                                            setOpenSearchingCity(false)
                                            setSearchingCity(CityArray)
                                        })}
                                        onTouchStart={() => {
                                            setCancelTouch(false)
                                        }}
                                        onTouchMove={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchCancel={() => {
                                            setCancelTouch(true)
                                        }}
                                        onTouchEnd={( async (event) => {
                                            event.preventDefault()
                                            if(!CancelTouch)
                                            {
                                                event.stopPropagation()
                                                await setSelectedCityAddStaff(el)
                                                document.getElementById('SearchingInputAddStaff City').value = document.getElementById('SearchingInputAddStaff City').defaultValue
                                                setOpenSearchingCity(false)
                                                setSearchingCity(CityArray)
                                            }
                                        })}
                                        >
                                            {el.City + ' ' + el.Adress}
                                        </button>
                                        )}
                                    </div>

                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    
                    <div
                    className="InputModalMainDiv AddStaff"
                    >
                        <div
                        className="InputModalTextDiv"
                        >
                            {'ФИО: '} 
                        </div>
                        <input
                        className="InputModal"
                        id='InputModalFIO'
                        value={AddStaffSlice.FIO}
                        onClick={(() => {
                            document.getElementById('InputModalFIO').classList.remove('Allert')
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                document.getElementById('InputModalFIO').classList.remove('Allert')
                                document.getElementById('InputModalFIO').focus()
                            }
                        })}
                        onChange={((e) => {
                            dispatch(ChangeValueAddStaff({Type: 'FIO', Value: String(e.target.value)}))
                        })}
                        />
                    </div>
                    
                    {!EditStaff && <div
                    className="InputModalMainDiv AddStaff"
                    >
                        <div
                        className="InputModalTextDiv"
                        >
                        {'Часов за смену: '} 
                        </div>
                        <input
                        className="InputModal"
                        id='InputModalShift'
                        type="Number"
                        value={AddStaffSlice.Shift}
                        onClick={(() => {
                            document.getElementById('InputModalShift').classList.remove('Allert')
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                document.getElementById('InputModalShift').classList.remove('Allert')
                                document.getElementById('InputModalShift').focus()
                            }
                        })}
                        onChange={((e) => {
                            if(e.target.value !== '' && e.target.value > 0)
                            {
                                dispatch(ChangeValueAddStaff({Type: 'Shift', Value: parseFloat(e.target.value)}))
                            }
                            else
                            {
                                dispatch(ChangeValueAddStaff({Type: 'Shift', Value: 0}))
                            }
                        })}
                        />
                    </div>}
                    {!EditStaff && <div
                    className="InputModalMainDiv AddStaff"
                    >
                        <div
                        className="InputModalTextDiv"
                        >
                        {'Премия за смену: '} 
                        </div>
                        <input
                        className="InputModal"
                        id='InputModalPrize'
                        type="Number"
                        value={AddStaffSlice.Prize}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(() => {
                            if(!CancelTouch)
                                document.getElementById('InputModalPrize').focus()
                        })}
                        onChange={((e) => {
                            if(e.target.value !== '' && e.target.value > 0)
                            {
                            dispatch(ChangeValueAddStaff({Type: 'Prize', Value: parseFloat(e.target.value)}))
                            }
                            else
                            {
                            dispatch(ChangeValueAddStaff({Type: 'Prize', Value: 0}))
                            }
                        })}
                        /> 
                        {' руб.'}
                    </div>}
                    {!EditStaff && <div
                    className="InputModalMainDiv AddStaff"
                    >
                        <div
                        className="InputModalTextDiv"
                        >
                        {'Ставка за смену: '} 
                        </div>
                        <input
                        className="InputModal"
                        id='InputModalRate'
                        type="Number"
                        value={AddStaffSlice.Rate}
                        onClick={(() => {
                            document.getElementById('InputModalRate').classList.remove('Allert')
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                document.getElementById('InputModalRate').classList.remove('Allert')
                                document.getElementById('InputModalRate').focus()
                            }
                        })}
                        onChange={((e) => {
                            if(e.target.value !== '' && e.target.value > 0)
                            {
                            dispatch(ChangeValueAddStaff({Type: 'Rate', Value: parseFloat(e.target.value)}))
                            }
                            else
                            {
                            dispatch(ChangeValueAddStaff({Type: 'Rate', Value: 0}))
                            }
                        })}
                        /> 
                        {' руб.'}
                    </div>}
                    <div
                    className="PostAddStaffGlobalDiv"
                    >
                        <div
                        className="PostAddStaffDivText"
                        id='PostAddStaffDivText'
                        onClick={(() => {
                            document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                        })}
                        >
                            {'Должность: '} 
                        </div>

                        <div
                        className="PostAddStaffTwoButtonsDiv"
                        >
                            <button
                            className={AddStaffSlice.Post === 'Кассир' ? "OnePostAddStaffButton Active" : "OnePostAddStaffButton"}
                            onClick={(() => {
                                dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Кассир'}))
                                setOpenInputPost(false)
                                document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Кассир'}))
                                    setOpenInputPost(false)
                                    document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                                }
                            })}
                            >
                                    Кассир
                            </button>


                            <button
                            className={(AddStaffSlice.Post === 'Повар' || AddStaffSlice.Post === 'Повар 1 группа') ? "OnePostAddStaffButton Active" : "OnePostAddStaffButton"}
                            onClick={(() => {
                                dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Повар 1 группа'}))
                                setOpenInputPost(false)
                                document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Повар 1 группа'}))
                                    setOpenInputPost(false)
                                    document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                                }
                            })}
                            >
                                    Повар 1 группа
                            </button>

                            <button
                            className={AddStaffSlice.Post === 'Повар 2 группа' ? "OnePostAddStaffButton Active" : "OnePostAddStaffButton"}
                            onClick={(() => {
                                dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Повар 2 группа'}))
                                setOpenInputPost(false)
                                document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Повар 2 группа'}))
                                    setOpenInputPost(false)
                                    document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                                }
                            })}
                            >
                                    Повар 2 группа
                            </button>
                        </div>                        

                        <div
                        className="PostAddStaffTwoButtonsDiv"
                        >
                            <button
                            className={AddStaffSlice.Post === 'Управляющий' ? "OnePostAddStaffButton Active" : "OnePostAddStaffButton"}
                            onClick={(() => {
                                dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Управляющий'}))
                                setOpenInputPost(false)
                                document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    dispatch(ChangeValueAddStaff({Type: 'Post', Value: 'Управляющий'}))
                                    setOpenInputPost(false)
                                    document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                                }
                            })}
                            >
                                    Управляющий
                            </button>

                            <button
                            className={OpenInputPost ? "OnePostAddStaffButton Active" : "OnePostAddStaffButton"}
                            onClick={(() => {
                                setOpenInputPost(true)
                                dispatch(ChangeValueAddStaff({Type: 'Post', Value: ''}))
                                document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    setOpenInputPost(true)
                                    dispatch(ChangeValueAddStaff({Type: 'Post', Value: ''}))
                                    document.getElementById('PostAddStaffDivText').classList.remove('Allert')
                                }
                            })}
                            >
                                    {'Другое (без %)'}
                            </button>
                        </div>
                    </div>
                    {OpenInputPost && 
                    <div
                    className="InputModalMainDiv AddStaff"
                    >
                        <div
                        className="InputModalTextDiv"
                        >
                        {'Укажите должность: '} 
                        </div>
                        <input
                        className="InputModal"
                        id='InputModal Post'
                        value={InputPostValue}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(() => {
                            if(!CancelTouch)
                                document.getElementById('InputModal Post').focus()
                        })}
                        onChange={((e) => {
                            setInputPostValue(e.target.value)
                        })}
                        />
                    </div>
                    }
                </div>
                
                <div
                className="ModalButtonsDiv"
                >
                    <button
                    className="ModalButton Cancle"
                    onClick={(() => {
                        if(!EditStaff)
                        {
                            dispatch(setOpenMainMenu(true))
                        }
                        else
                        {
                            dispatch(setOpenStaffManagment(true))
                            dispatch(setOpenRevenue(true))
                        }
                        dispatch(setOpenModalAddStaff(false))
                        dispatch(CleanValueAddStaff())
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            if(!EditStaff)
                            {
                                dispatch(setOpenMainMenu(true))
                            }
                            else
                            {
                                dispatch(setOpenStaffManagment(true))
                                dispatch(setOpenRevenue(true))
                            }
                            dispatch(setOpenModalAddStaff(false))
                            dispatch(CleanValueAddStaff())
                        }
                    })}
                    >
                        Отмена
                    </button>

                    <button
                    className="ModalButton Save"
                    onClick={handleClickSaveButton}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            handleClickSaveButton(event)
                    }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddStaffModalWindow;
